import React, { useEffect, useState } from "react";
import { Box, Text, Flex, Input, CircularProgress , useToast, Checkbox } from "@chakra-ui/react";
import fileUpload from "../../providers/fileUpload"
import c from "../../constant"
import UploadingModal from "../UploadingModal/UploadingModal"
import { useTranslation } from "react-i18next";

const PDFPicker =React.memo(function ({initContent, onContentChange}) {
    const { t } = useTranslation();
    const toast = useToast()
    const [original, setOriginal] = useState(initContent?.file);
    
    const [fileName, setFileName] = useState(initContent?.fileName);
    const [fileSize, setFileSize] = useState(initContent?.fileSize);
    
    const [updated, setUpdated] = useState(false)

    const [loading, setLoading] = useState(false)
    const [error, serError] = useState(false)

    const [isDefaultDownload, setIsDefaultDownload] = useState(initContent?.isDefaultDownload?initContent?.isDefaultDownload:false)
    
    function errorMessage(type){
        toast({
            title: `File type of ${type} failed to upload`,
            status: "error",
            position:"top-right",
            isClosable: true,
        })
    }


    useEffect(()=>{
        if(original){
            const content = {
                file:original,
                fileName,
                fileSize,
                isDefaultDownload: isDefaultDownload
            }
            onContentChange(content)
        }
    },[original,fileName, isDefaultDownload])

    function fileChangedHandler(event) {
        var fileInput = false;
        if (event.target.files[0]) {
            setFileSize(event.target.files[0].size)
            fileInput = true;
        }
        if (fileInput) {
            setLoading(true)
            fileUpload(event.target.files[0]).then(response=>{
                setOriginal(response);
                setUpdated(true)
                setLoading(false)
            }).catch((error)=>{
                setLoading(false)
                errorMessage("PDF")
                serError(true)
            })
        }
    }

    return (
        <>
        <Box bg="gray.200" p="4" mb="4" borderRadius={c.borderRadius}>
            <Flex alignItems="center" mt="4" mb="4">
                <Text fontWeight="bold" mr="8">
                    {t("Please choose a PDF file")}
                </Text>
                {loading&&<>
                        <CircularProgress size="32px" isIndeterminate color="orange.300" />
                        <Text ml="2">{t("Uploading File, Please wait until the upload finishes")}</Text>
                </>}
            </Flex>
            <input
                id="file"
                type="file"
                accept="application/pdf application/msword"
                onChange={fileChangedHandler}
            />
            <br />
            {(!updated && (initContent?.file))&&<Text>{initContent?.file}</Text>}
            <Flex mt="4" alignItems="center">
                <Text mr="2">{t("Enter File Name")}</Text>
                <Input
                    bg="white"
                    w="200px"
                    id="file-name"
                    type="text"
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                />
            </Flex>
            <Flex mt="4" p="3px" pl="2" bg="white" w="230px" >
                <Checkbox onChange={()=>{
                    const val = !isDefaultDownload
                    setIsDefaultDownload(val)
                }}  isChecked={isDefaultDownload}>{t("Set as default download")}</Checkbox>
            </Flex>
        </Box>
        <UploadingModal isOpen={(!error&&loading)}/>
        </>
    );
});

export default PDFPicker;
